/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { routes } from "@bvi/admin-panel/api-routes";
import { apiContainer, getItemTags, getListTag, invalidateTags, provideTagsList, TagTypes } from "@bvi/admin-panel/shared/api";
import { getResponseData } from "@bvi/api-interfaces/response";
import {
  IManageBaseListResponse,
  IManageBaseResponse
} from '@bvi/api-interfaces/response/manage-base-data';

interface ICreateCountryRequest {
  name: string;
}

export const countryApi = apiContainer.injectEndpoints({
  endpoints: (builder) => ({
    getCountryList: builder.query<IManageBaseListResponse, void>({
      query: () => ({
        url: routes.countries.findAll(),
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
            ...getItemTags(TagTypes.COUNTRY, getResponseData(result)),
            getListTag(TagTypes.COUNTRY),
          ]
          : [getListTag(TagTypes.COUNTRY)],
    }),

    getByIdCountry: builder.query<IManageBaseResponse, number>({
      query: (id) => ({
        url: routes.countries.findOne(id),
        method: 'GET',
      }),
      providesTags: provideTagsList(TagTypes.COUNTRY)
    }),

    createCountry: builder.mutation<
      IManageBaseResponse,
      ICreateCountryRequest
    >({
      query: (data) => ({
        url: routes.countries.create(),
        method: 'POST',
        data,
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.COUNTRY)),
    }),

    updateCountry: builder.mutation<
      IManageBaseResponse,
      { id: number; name: string }
    >({
      query: ({ id, name }) => ({
        url: routes.countries.update(id),
        method: 'PATCH',
        data: { name },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.COUNTRY)),
    }),

    deleteCountry: builder.mutation<void, number>({
      query: (id) => ({
        url: routes.countries.remove(id),
        method: 'DELETE',
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.COUNTRY)),
    }),
  })
});

export const {
  useGetCountryListQuery,
  useLazyGetCountryListQuery,
  useGetByIdCountryQuery,
  useLazyGetByIdCountryQuery,
  useCreateCountryMutation,
  useUpdateCountryMutation,
  useDeleteCountryMutation
} = countryApi;

